import { ICronJobTrackerProps } from '@/pages/CronJobsTracker/cronJobsTracker.interface';

export const CRON_JOBS_TRACKER_UI_PROPS = {
  JOB_NAME_DROPDOWN: {
    LABEL: 'Job Name',
    PLACEHOLDER: 'Select Job Name',
  },
};
export interface ECronJobNameInterface {
  jobName: string;
  value: string;
}
export const ECronJobTypeDropdownOptionsList = [
  {
    jobName: 'All Jobs',
    value: '',
  },
  {
    jobName: 'Send To Inventory V1',
    value: 'SEND_TO_INVENTORY_V1',
  },
  {
    jobName: 'Send To Inventory V2',
    value: 'SEND_TO_INVENTORY_V2',
  },
  {
    jobName: 'Send To Partners V1',
    value: 'SEND_TO_PARTNERS_V1',
  },
  {
    jobName: 'Send To Partners V2',
    value: 'SEND_TO_PARTNERS_V2',
  },
  {
    jobName: 'Process VDI Transactions',
    value: 'PROCESS_VDI_TRANSACTIONS',
  },
  {
    jobName: 'Send To Client V2',
    value: 'SEND_TO_CLIENT_V2',
  },
  {
    jobName: 'SS Reconciliation',
    value: 'SS_RECONCILIATION',
  },
  {
    jobName: 'SS Reconciliation PT',
    value: 'SS_RECONCILIATION_PT',
  },
  {
    jobName: 'SS Reconciliation PS',
    value: 'SS_RECONCILIATION_PS',
  },
  {
    jobName: 'Targeted Reconciliation',
    value: 'TARGETED_RECONCILIATION',
  },
  {
    jobName: 'Retry Failed VDI Requests V1',
    value: 'RETRY_FAILED_VDI_REQUESTS_V1',
  },
  {
    jobName: 'Retry Failed VDI Requests V2 Partner',
    value: 'RETRY_FAILED_VDI_REQUESTS_V2_PARTNER',
  },
  {
    jobName: 'Retry Failed VDI Requests V2 Client',
    value: 'RETRY_FAILED_VDI_REQUESTS_V2_CLIENT',
  },
  {
    jobName: 'Retry Failed Client VDI Get State',
    value: 'RETRY_FAILED_CLIENT_VDI_GET_STATE',
  },
  {
    jobName: 'Check Client VDI Get State',
    value: 'CHECK_CLIENT_VDI_GET_STATE',
  },
  {
    jobName: 'Master Node Discovery',
    value: 'MASTER_NODE_DISCOVERY',
  },
  {
    jobName: 'Process Alerts',
    value: 'PROCESS_ALERTS',
  },
  {
    jobName: 'Check Alert State',
    value: 'CHECK_ALERT_STATE',
  },
  {
    jobName: 'Patch Alerts',
    value: 'PATCH_ALERTS',
  },
];
